import clsx from 'clsx';
import PropTypes from 'prop-types';

export function Button({
  children,
  onClick,
  onKeyDown,
  type = 'button',
  disabled = false,
  size,
  variant,
}) {
  return (
    <button
      type={type}
      disabled={disabled}
      onClick={onClick}
      onKeyDown={onKeyDown}
      className={clsx(
        {
          'rounded-lg px-2 py-1 text-xs': size === 'xs',
          'rounded-xl px-3 py-2 text-sm': size === 'sm',
          'rounded-2xl px-4 py-2': size === 'base',
          'rounded-full px-6 py-3 text-xl': size === 'lg',
          'bg-indigo-400/60 text-indigo-900 shadow dark:bg-indigo-800/60 dark:text-indigo-100':
            variant === 'primary',
          'bg-indigo-300/20 text-indigo-900 shadow-sm dark:bg-indigo-900/20 dark:text-indigo-100':
            variant === 'secondary',
          'text-indigo-900 hover:bg-indigo-100 dark:text-indigo-100 dark:hover:bg-indigo-900/10':
            variant === 'tertiary',
        },
        disabled
          ? 'opacity-60'
          : {
              'opacity-90 hover:opacity-100 hover:shadow-md':
                variant === 'primary',
              'opacity-80 hover:opacity-100 hover:shadow-md':
                variant === 'secondary',
              'opacity-80 hover:opacity-100 hover:shadow':
                variant === 'tertiary',
            }
      )}
    >
      {children}
    </button>
  );
}

Button.propTypes = {
  /** What is inside? */
  children: PropTypes.node.isRequired,
  /** Decides opacity of the button */
  disabled: PropTypes.bool,
  /** handle click event */
  onClick: PropTypes.func,
  /** handle keyboard event */
  onKeyDown: PropTypes.func,
  /** button size */
  size: PropTypes.oneOf(['xs', 'sm', 'base', 'lg']).isRequired,
  /** button type */
  type: PropTypes.oneOf(['button', 'submit']),
  /** button variant */
  variant: PropTypes.oneOf(['primary', 'secondary', 'tertiary']).isRequired,
};
